import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useGetJournalEntryDetails } from "../../../../hooks/api/queries";

const EditJournalEntry = () => {
  const navigate = useNavigate();
  const { reference } = useParams();
  const {
    data: journalEntryDetails,
    isFetching: isFetchingJournalEntryDetails,
  } = useGetJournalEntryDetails(reference, {
    enabled: !!reference,
  });

  return (
    <>
      <secondaryComponents.LoaderHelper
        classNames="mt-5"
        isLoading={isFetchingJournalEntryDetails}
      >
        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
          <primaryComponents.Button
            classNames="btn btn--outline"
            onClick={() => navigate(-1)}
          >
            <FontAwesomeIcon
              icon="angle-left"
              className="mr-3"
              style={{ fontSize: "18px" }}
            />
            <span>Back</span>
          </primaryComponents.Button>

          <h4 className="font-weight-semibold mb-0">Edit Manual Journal</h4>
        </div>
        <secondaryComponents.JournalEntryForm
          isEditMode={true}
          draftJournalEntryDetails={journalEntryDetails}
        />
      </secondaryComponents.LoaderHelper>
    </>
  );
};

export default EditJournalEntry;
